import { Status } from '../status/status';

export class Param {
    id: number;
    upLimit: number;
    
    status: Status;    
}